import styles from './index.module.sass';
import mixingSvg from '@@/mixing/images/mixing.svg';
import sleevesSvg from '@@/mixing/images/sleeves.svg';
import stationarySvg from '@@/mixing/images/stationary-mono.svg';
import { ButtonMain } from '@/modules/common/components/button';
import { declineWord } from '@/modules/common/helpers/decline-word.helper';

export const ManualMixingResultItem = ({
  title,
  weight,
  mixData,
  noMixData,
  warehouseType,
}: IArgs) => {
  return (
    <div className={styles.root}>
      <div className={styles.top}>
        <span className={styles.title}>{title}</span>
        <span className={styles.weight}>{weight?.toLocaleString('ru')} т</span>
      </div>
      <div className={styles.section}>
        <div className={styles.data}>
          <img src={warehouseType === '1' ? stationarySvg : sleevesSvg} className={styles.icon} alt="icon" />
          <span className={styles.label}>подходящее зерно <br/> без миксования</span>
        </div>
        <div className={styles.side}>
          <span className={styles.weight}>{noMixData.weigth?.toLocaleString('ru')} т</span>
          <span className={styles.count}>({warehouseType === '2'
            ? declineWord(Number(noMixData.count), ['рукавов', 'рукав', 'рукава'])
            : declineWord(Number(noMixData.count), ['объёмов', 'объём', 'объёма'])
          })</span>
        </div>
        <ButtonMain
          className={styles.action}
          onClick={noMixData.action}
          label={'показать'}
          active={noMixData.count > 0}
        />
      </div>
      <div className={styles.section}>
        <div className={styles.data}>
          <img src={mixingSvg} className={styles.icon} alt="icon" />
          <span className={styles.label}>требуется <br/>миксование</span>
        </div>
        <div className={styles.side}>
          <span className={styles.weight}>{mixData.weigth?.toLocaleString('ru')} т</span>
          <span className={styles.count}>({declineWord(mixData.count, ['миксов', 'микс', 'микса', 'миксов'])})</span>
        </div>
        <ButtonMain
          className={styles.action}
          onClick={mixData.action}
          label={'показать'}
          active={mixData.count > 0}
        />
      </div>
    </div>
  );
};

interface IArgs {
  title: string;
  weight: number;
  mixData: ISectionData;
  noMixData: ISectionData;
  warehouseType: '1' | '2'
}

interface ISectionData {
  action: () => void;
  weigth: number;
  count: number;
}
